import { render, staticRenderFns } from "./HeatmapIncome.vue?vue&type=template&id=5c8e3b1a&lang=pug&"
import script from "./HeatmapIncome.vue?vue&type=script&lang=ts&"
export * from "./HeatmapIncome.vue?vue&type=script&lang=ts&"
import style0 from "./HeatmapIncome.vue?vue&type=style&index=0&id=5c8e3b1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports